import { BaseProperties, DispensationProperties } from '@memed/x-ray-tracker-js/types/context';
import { trackEvent } from '../x-ray-tracker';

type Properties = BaseProperties
export interface TrackPageViewParams {
  pageName: string;
  properties?: DispensationProperties;
  category?: string;
}

const eventName = 'page_view';
const category = 'dispensador';

type PageViewProperties = {
  properties: Properties;
  page: string;
}

export function trackPageView({
  page,
  properties,
  ...rest
}: PageViewProperties): boolean {
  const mergedProperties = {
    ...properties,
    ...rest,
    category,
  }
  return trackEvent(eventName, page, mergedProperties);
}

